/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {PartNumberChangesTrialRejectDetailModel} from '../../services/part-number-changes-detail-configuration/models/pnc-trial/part-number-changes-trial-reject-detail.model';
import {NgStyle} from '@angular/common';

@Component({
    selector: 'app-part-number-changes-reject-motivation',
    templateUrl: './part-number-changes-reject-motivation.component.html',
    styleUrls: ['../../part-number-changes-detail/part-number-changes-detail.component.css',
        '../../styles/pnc-base.component.css',
        '../part-number-changes-old-credentials.component.css',
        './part-number-changes-reject-motivation.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartNumberChangesRejectMotivationComponent {
    @Input() trialRejectionMotivation: PartNumberChangesTrialRejectDetailModel | undefined;
    @Input() trialWrapperStyle: NgStyle;
}
